import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.unittype.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_UNIT_TYPE_ASYNC: `${uid}.saveUnitTypeAsync`,
    SAVE_UNIT_TYPE_SUCCESS: `${uid}.saveUnitTypeSuccess`,
    SAVE_UNIT_TYPE_FAILURE: `${uid}.saveUnitTypeFailure`,
    UPLOAD_PHOTO_ASYNC: `${uid}.uploadPhotoAsync`,
    UPLOAD_PHOTO_SUCCESS: `${uid}.uploadPhotoSuccess`,
    UPLOAD_PHOTO_FAILURE: `${uid}.uploadPhotoFailure`,
    CREATE_UNIT_TYPE: `${uid}.createUnitType`
};

export { ActionTypes };
